import React, {forwardRef, useState} from 'react';
import style from './style';
import clsx from "clsx";
import i18next from "i18next";
import EAColorIcon from '../../../common/EAColorIcon';

const FicheContextMenu = forwardRef(({navigationItems, additionalClass}, ref) => {
  const {classes} = style();
  const [selectedAnchor, setSelectedAnchor] = useState();

  function getScrollableParent(element) {
    let parent = element.parentElement;
    while (parent) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') {
        return parent;
      }
      parent = parent.parentElement;
    }
    return window;
  }

  return <>
    <div className={clsx(classes.root, additionalClass)} ref={ref}>

      <div className={clsx(classes.navigation, 'nav')}>
        {navigationItems.map((item) =>
          <div
            onClick={() => {
              setSelectedAnchor(item.id);
              const el = document.getElementById(item.id);
              const scrollContainer = getScrollableParent(el);

              const yOffset = -120;
              if (scrollContainer === window) {
                const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
              } else {
                const y = el.offsetTop + yOffset;
                scrollContainer.scrollTo({ top: y, behavior: 'smooth' });
              }
            }}
            className={
              clsx(classes.navigationItem, selectedAnchor === item.id ? 'selected' : '')
            }
            key={item.id}
          >
            <EAColorIcon icon={item.icon} svgStyle={{position: "relative", top: "3px"}}/>
            <span className={classes.navigationItemText}>
            {i18next.t(item.label)}
          </span>
          </div>
        )}
      </div>

    </div>
  </>
})

export default FicheContextMenu;